import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataSeriesItemValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                name: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                },
                data: {
                    type: 'array',
                    empty: false,
                    mandatory: false
                },
                pointStart: {
                    type: 'number',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
